import { useSetAtom } from 'jotai';
import { updateEDTInfoPayloadAtom } from './atom';

export const useOpenUpdateEDTInfoModal = () =>
  useSetAtom(updateEDTInfoPayloadAtom);
